import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(URL);

export const fetchLimits = (params) => {
    return axios.get('/api/v1/limits/', { params });
};

export const adminFetchLimits = (params) => {
    return axios.get('/api/v1/admin/payment/limits/', { params });
};
